import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService, RequestBuilder, RequestTypeEnum } from '@client-monorepo/common/network';
import { InAppMessageApiResponseType } from '../models/in-app-message-api-response.type';

@Injectable({
  providedIn: 'root',
})
export class InAppMessagesApiService {
  apiService = inject(ApiService);

  getMessages(): Observable<InAppMessageApiResponseType> {
    const request = new RequestBuilder(RequestTypeEnum.GET, 'messages');
    return this.apiService.call(request);
  }

  readMessage(uid: string): Observable<any> {
    const request = new RequestBuilder(RequestTypeEnum.POST, 'messages/' + uid + '/read');
    return this.apiService.call(request);
  }
}
